import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Node, Editor } from 'slate';
import { Editable, Slate } from '@seafile/slate-react';
import Toolbar, { HelpGroup } from '../components/toolbar';
import ModalPortal from '../components/modal-portal';
import ContextMenu from '../components/context-menu';
import TextLinkHoverMenu from '../components//text-link-hover-menu';
import AddLinkDialog from '../components/dialogs/add-link-dialog';
import KeyboardShortcuts from '../components/dialogs/shortcut-dialog';
import { deserialize, serialize } from '../utils/slate2markdown/index';
import { isRangeCollapsed } from '../containers/editor-utils/range-utils';
import { renderNode, renderLeaf, decorationNode } from '../containers/render-utils/editor-utils';
import EditorContext from '../containers/editor-context';
import '../containers/code-highlight-package';
import '../assets/editor/simple-editor.css';
import '../assets/css/image.css';
import '../assets/css/link.css';
import '../assets/css/navbar-imgbutton.css';
var SimpleEditor = /*#__PURE__*/function (_React$Component) {
  _inherits(SimpleEditor, _React$Component);
  var _super = _createSuper(SimpleEditor);
  function SimpleEditor(props) {
    var _this;
    _classCallCheck(this, SimpleEditor);
    _this = _super.call(this, props);
    _this.onChange = function (value) {
      _this.setState({
        value: value
      });

      // hide context menu when content change
      if (_this.state.isShowContextMenu === true) {
        _this.setState({
          isShowContextMenu: false
        });
        _this.contextMenuPosition = {};
      }
      var operations = _this.editor.operations;
      var hasChange = operations.some(function (o) {
        return o.type !== 'set_selection' && o.type !== 'set_value';
      });
      if (hasChange) _this.contentChanged = true;
    };
    _this.onFocusEditor = function () {
      var value = _this.state.value;
      if (value.length === 1 && value[0].type === 'paragraph' && Node.text(value[0].children[0]).length === 0) {
        _this.editorRef.firstChild.focus();
      }
    };
    _this.focusText = function () {
      // In dtable long text editor, press the key to open the editor.
      // Then the cursor should move to the end of this character.
      var _this$props = _this.props,
        focusEnd = _this$props.focusEnd,
        value = _this$props.value;
      if (focusEnd === true && value.length === 1) {
        setTimeout(function () {
          Editor.select(_this.editor, {
            path: [0, 0],
            offset: 1
          });
        }, 1);
      }
    };
    _this.hasContentChange = function () {
      return _this.contentChanged;
    };
    _this.onContextMenu = function (event) {
      if (_this.tableUtils.isInTable()) {
        event.preventDefault();
        _this.contextMenuPosition = {
          left: event.clientX,
          top: event.clientY
        };
        _this.setState({
          isShowContextMenu: !_this.state.isShowContextMenu
        });
      }
    };
    _this.onCut = function (event) {
      _this.editorUtils.onCut(event);
    };
    _this.onCopy = function (event) {
      _this.editorUtils.onCopy(event, _this.editor);
    };
    _this.onKeyDown = function (event) {
      _this.editorUtils.onKeyDown(event);
    };
    _this.toggleShortcutDialog = function () {
      _this.setState({
        isShowShortcutDialog: !_this.state.isShowShortcutDialog
      });
    };
    _this.onToggleLinkDialog = function () {
      _this.setState({
        isShowLinkDialog: !_this.state.isShowLinkDialog
      });
    };
    _this.setEditorRef = function (ref) {
      _this.editorRef = ref;
    };
    _this.state = {
      value: deserialize(props.value),
      isShowBigImage: false,
      isShowContextMenu: false,
      isShowShortcutDialog: false,
      isShowLinkDialog: false
    };
    _this.editor = EditorContext.getEditor(props);
    _this.editorUtils = EditorContext.getEditorUtils();
    _this.tableUtils = EditorContext.getTableUtils();
    _this.contextMenuPosition = {};
    return _this;
  }
  _createClass(SimpleEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.onRef(this);
      this.focusText();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      EditorContext.resetEditor();
    }
  }, {
    key: "getMarkdown",
    value: function getMarkdown() {
      this.contentChanged = false;
      return serialize(this.state.value);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: "render",
    value: function render() {
      var editor = this.editor;
      var value = this.state.value;
      var toolbarStatus = this.editorUtils.getToolbarStatus();
      var _this$props2 = this.props,
        readOnly = _this$props2.readOnly,
        t = _this$props2.t;
      var selectionCollapsed = isRangeCollapsed(editor.selection);
      return /*#__PURE__*/React.createElement("div", {
        className: "seafile-simple-editor"
      }, /*#__PURE__*/React.createElement("div", {
        className: "seafile-editor-topbar"
      }, /*#__PURE__*/React.createElement(Toolbar, {
        isSimpleEditor: true
      }), /*#__PURE__*/React.createElement(HelpGroup, {
        onHelpToggle: this.toggleShortcutDialog
      })), /*#__PURE__*/React.createElement(Slate, {
        editor: this.editor,
        value: value,
        onChange: this.onChange
      }, /*#__PURE__*/React.createElement("div", {
        className: "seafile-editor-module editor-container"
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.setEditorRef,
        onClick: this.onFocusEditor,
        className: "editor article"
      }, /*#__PURE__*/React.createElement(Editable, {
        autoFocus: true,
        renderElement: function renderElement(props) {
          return renderNode(props, editor, readOnly);
        },
        className: 'editor-component',
        renderLeaf: renderLeaf,
        onContextMenu: this.onContextMenu,
        onCut: this.onCut,
        onCopy: this.onCopy,
        onKeyDown: this.onKeyDown,
        decorate: decorationNode
      })), toolbarStatus.isLinkActive && selectionCollapsed ? /*#__PURE__*/React.createElement(ModalPortal, null, /*#__PURE__*/React.createElement(TextLinkHoverMenu, {
        onToggleLinkDialog: this.onToggleLinkDialog,
        editorUtils: this.editorUtils
      })) : null, this.state.isShowContextMenu && /*#__PURE__*/React.createElement(ModalPortal, null, /*#__PURE__*/React.createElement(ContextMenu, {
        tableUtils: this.tableUtils,
        contextMenuPosition: this.contextMenuPosition
      })), this.state.isShowShortcutDialog && /*#__PURE__*/React.createElement(KeyboardShortcuts, {
        userHelp: t('userHelp', {
          returnObjects: true
        }),
        toggleShortcutDialog: this.toggleShortcutDialog
      }), this.state.isShowLinkDialog && /*#__PURE__*/React.createElement(AddLinkDialog, {
        toggleLinkDialog: this.onToggleLinkDialog
      }))));
    }
  }]);
  return SimpleEditor;
}(React.Component);
export default withTranslation('seafile-editor')(SimpleEditor);